import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface ConfirmResetPasswordFormProps {
	email: string;
}

export const ConfirmResetPasswordForm = ({ email }: ConfirmResetPasswordFormProps) => {
	const [searchParams] = useSearchParams();
	const confirmationUrl = searchParams.get('confirmation_url');

	if (!confirmationUrl) {
		return (
			<div className="space-y-4">
				<div className="p-3 text-sm text-red-600 bg-red-50 rounded-md flex items-start gap-2">
					<AlertCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
					<span>Missing confirmation URL. Please request a new password reset link.</span>
				</div>
				<div className="text-center">
					<a
						href="/auth?view=forgot_password"
						className="text-blue-500 hover:text-blue-400 hover:underline"
					>
						Go to forgot password page
					</a>
				</div>
			</div>
		);
	}

	return (
		<div className="space-y-6">
			<div className="space-y-4">
				<a href={decodeURIComponent(confirmationUrl)}>
					<Button className="w-full">Confirm Password Reset</Button>
				</a>
			</div>

			<div className="text-sm text-center text-muted-foreground">
				<p className="mt-2">
					If you didn't request a password reset, you can safely ignore this and{' '}
					<a
						href="/auth?view=sign_in"
						className="text-blue-500 hover:text-blue-400 hover:underline"
					>
						return to sign in
					</a>
					.
				</p>
			</div>
		</div>
	);
};
